/**
 * Polish UI dictionary. ONLY interface chrome lives here — all business copy
 * (services, companies, articles…) is delivered by the CMS via GraphQL.
 */
export const pl = {
	common: {
		skipToContent: "Przejdź do treści",
		loading: "Ładowanie…",
		error: "Wystąpił błąd",
		retry: "Spróbuj ponownie",
		close: "Zamknij",
		menu: "Menu",
		search: "Szukaj",
		searchPlaceholder: "Czego szukasz?",
		readMore: "Czytaj więcej",
		backHome: "Wróć na stronę główną",
		demoBadge: "DEMO",
	},
	nav: {
		services: "Usługi",
		companies: "Spółki",
		caseStudies: "Realizacje",
		knowledge: "Baza wiedzy",
		resources: "Raporty i materiały",
		webinars: "Webinary",
		contact: "Kontakt",
		search: "Wyszukiwarka",
	},
	switcher: {
		language: "Język",
		polish: "Polski",
		english: "Angielski",
		theme: "Motyw",
		light: "Jasny",
		dark: "Ciemny",
		system: "Systemowy",
	},
	form: {
		required: "Pole wymagane",
		invalidEmail: "Nieprawidłowy adres e-mail",
		invalidPhone: "Nieprawidłowy numer telefonu",
		consentRequired: "Wymagana zgoda",
		submit: "Wyślij",
		submitting: "Wysyłanie…",
		success: "Dziękujemy. Wiadomość została wysłana.",
		genericError: "Nie udało się wysłać formularza. Spróbuj ponownie.",
		duplicate: "Otrzymaliśmy już Twoje zgłoszenie.",
	},
	errors: {
		notFoundTitle: "Nie znaleziono strony",
		notFoundBody: "Strona, której szukasz, nie istnieje lub została przeniesiona.",
		serverTitle: "Coś poszło nie tak",
		serverBody: "Pracujemy nad rozwiązaniem problemu. Spróbuj ponownie za chwilę.",
	},
	assistant: {
		title: "Asystent AI",
		placeholder: "Zadaj pytanie o usługi Grupy…",
		disclaimer: "Odpowiedzi mają charakter poglądowy (funkcja w przygotowaniu).",
	},
} as const;
